module.exports = __webpack_public_path__ + "img/acreditacion_1.bc3544d5.png";